// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subheader[data-v-18dfa3e1] {\n  background: #0033a0;\n  background: linear-gradient(90deg, #0033a0 0%, #4f80e9 100%);\n}\n.instructionChip[data-v-18dfa3e1] {\n  font-size: 0.75rem;\n  font-weight: 500;\n  text-indent: 0.0892857143em;\n  letter-spacing: 0.0892857143em;\n}\n.scroller[data-v-18dfa3e1] {\n  height: 100%;\n}\n.user[data-v-18dfa3e1] {\n  height: 100px;\n  display: flex;\n}\n.wrapper[data-v-18dfa3e1] {\n  height: 200px;\n}", ""]);
// Exports
module.exports = exports;
